export default __webpack_public_path__ + "static/media/BebasKai.6d02e3d2.ttf";